import axios from 'axios'
import { VUE_APP_WX_SIGNATURE_URL } from '../variables/wechat.js'

export function getWechat () {
  return axios
    .get(VUE_APP_WX_SIGNATURE_URL, {
      params: { shareUrl: window.location.href.split('#')[0] }
    })
    .then(res => res.data.data)
}
